import React from "react";
import { CardSlots, CardSlotsProps } from "@/components/game/card-slots";
import { Button } from "@/components/ui/button";

export interface PlayedCardsSectionProps {
  opponentCards: string[];
  playerCards: string[];
  isOpponent?: boolean;
  opponentId?: number;
  isRoundEnded?: boolean;
  isMatchEnded?: boolean;
  isHost?: boolean;
  cardsDealt?: boolean;
  onDealCards?: () => void;
  onStartNewRound?: () => void;
  under10ButtonShown?: boolean;
  isUnder10?: boolean;
  isCurrentTurn?: boolean;
  onUnder10Replace?: () => void;
  gameRoom?: { lastRoundWinner?: number; name?: string };
  isSpectator?: boolean;
}

export const PlayedCardsSection: React.FC<PlayedCardsSectionProps> = ({
  opponentCards,
  playerCards,
  isOpponent = false,
  opponentId,
  isRoundEnded = false,
  isMatchEnded = false,
  isHost = false,
  cardsDealt = false,
  onDealCards,
  onStartNewRound,
  under10ButtonShown = false,
  isUnder10 = false,
  isCurrentTurn = false,
  onUnder10Replace,
  gameRoom,
  isSpectator = false,
}) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center">
      {/* Opponent's played card slots */}
      <div className="-mt-[calc(1vh)] sm:-mt-[calc(1.5vh)] md:-mt-[calc(2vh)]">
        <CardSlots
          cards={opponentCards}
          isOpponent={true}
          opponentId={opponentId}
        />
      </div>

      {/* Game control buttons */}
      <div className="flex gap-2 mb-4 mt-2">
        {!cardsDealt && isHost && (
          <Button
            onClick={onDealCards}
            size="sm"
            className="bg-gradient-to-r from-primary/90 to-primary shadow-lg shadow-primary/20 border border-primary/20 text-black font-medium animate-pulse"
          >
            Deal Cards
          </Button>
        )}
        {isRoundEnded && !isMatchEnded && isHost && (
          <Button
            onClick={onStartNewRound}
            size="sm"
            className="bg-gradient-to-r from-primary/90 to-primary shadow-lg shadow-primary/20 border border-primary/20 text-black font-medium"
          >
            Start New Round
          </Button>
        )}
        {isMatchEnded && isHost && (
          <Button
            onClick={() => window.location.href = "/games"}
            size="sm"
            className="bg-gradient-to-r from-primary/90 to-primary shadow-lg shadow-primary/20 border border-primary/20 text-black font-medium"
          >
            End Game
          </Button>
        )}
      </div>

      {/* Under 10 button */}
      {isUnder10 && under10ButtonShown && isCurrentTurn && (
        <div className="flex flex-col items-center mb-2">
          <div className="bg-emerald-600/90 text-white font-semibold text-sm py-1 px-3 rounded mb-2 animate-pulse">
            Under 10 Deck!
          </div>
          <Button
            onClick={onUnder10Replace}
            variant="default"
            className="bg-primary hover:bg-primary/90 text-white shadow-lg animate-bounce"
          >
            Replace 2 Cards
          </Button>
        </div>
      )}

      {/* Current player's played card slots */}
      <div className="-mb-[calc(1vh)] sm:-mb-[calc(1.5vh)] md:-mb-[calc(2vh)]">
        <CardSlots
          cards={playerCards}
        />
      </div>
    </div>
  );
};
